<template>
  <div class="tab">
    <ul v-if="plan.comentarios.length" class="hilo">
      <li v-for="c in plan.comentarios" :key="c.idComentario" class="msg">
        <div class="msg-cab">
          <span class="autor">{{ c.autor || "—" }}</span>
          <span class="fecha">{{ c.fecha }}</span>
        </div>
        <p class="cuerpo">{{ c.cuerpo }}</p>
      </li>
    </ul>

    <p v-else class="vacio">Sin comentarios todavía.</p>

    <div class="alta">
      <textarea
        v-model="texto"
        rows="3"
        class="inp"
        placeholder="Escribe un comentario para el equipo…"
      ></textarea>
      <div class="alta-pie">
        <!-- Las menciones con @ quedan para la Fase 2 (ver ANALISIS.md). -->
        <span class="nota">Todos los involucrados en el plan reciben notificación.</span>
        <button
          class="btn"
          :disabled="!texto.trim() || enviando"
          :style="{ background: !texto.trim() || enviando ? '#cbd5e1' : '#003ca5' }"
          @click="enviar"
        >
          {{ enviando ? "Enviando…" : "Comentar" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabComentarios",
  props: {
    plan: { type: Object, required: true },
    enviando: { type: Boolean, default: false },
  },
  emits: ["comentar"],
  data() {
    return { texto: "" };
  },
  methods: {
    enviar() {
      const t = this.texto.trim();
      if (!t || this.enviando) return;
      this.$emit("comentar", t);
      this.texto = "";
    },
  },
};
</script>

<style scoped>
.tab {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.hilo {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.msg {
  border-left: 3px solid var(--pt-border);
  padding: 4px 0 4px 12px;
}
.msg-cab {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.autor {
  font-size: 13px;
  font-weight: 600;
}
.fecha {
  font-size: 11px;
  color: var(--pt-muted);
}
.cuerpo {
  margin: 4px 0 0;
  font-size: 14px;
  color: var(--pt-dim);
  white-space: pre-wrap;
}
.vacio {
  font-size: 14px;
  color: var(--pt-muted);
  text-align: center;
  padding: 24px 0;
  margin: 0;
}
.alta {
  border-top: 1px solid var(--pt-border);
  padding-top: 14px;
}
.inp {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid var(--pt-border);
  outline: none;
  background: var(--pt-card);
  color: var(--pt-text);
  box-sizing: border-box;
  font-family: inherit;
  resize: none;
}
.inp:focus {
  border-color: #003ca5;
}
.alta-pie {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
}
.nota {
  font-size: 11px;
  color: var(--pt-muted);
}
.btn {
  padding: 8px 18px;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
}
.btn:disabled {
  cursor: not-allowed;
}
</style>
